export default __webpack_public_path__ + "static/media/2_0034.cc30ba43.webp";